import {
    Grid,
    IconButton,
    InputAdornment,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteIcon from "@material-ui/icons/Delete";
import { Fragment } from "react";
import MeditocModal from "../../../utils/MeditocModal";
import { useEmpresa } from "../../../../context/EmpresaContext";
import { useStyle } from "../../../../context/StyleContext";

export default function CargarArchivo() {
    const { classes } = useStyle();
    const {
        listaProductos,
        listaFoliosArchivoVerificado,
        archivoCargadoFolios,
        modalOpenSubirArchivo,
        formCargarArchivo,
        handleOpenSubirArchivo,
        handleChangeCargarArchivo,
        handleClickCargarArchivo,
        handleClickVerificarArchivoFolios,
        handleClickLimpiarArchivo,
        handleSubmitVerificarArchivo,
    } = useEmpresa();

    const { txtProducto, txtArchivoFolios } = formCargarArchivo;

    return (
        <MeditocModal
            title="Generar folios desde archivo"
            okmessage="Siguiente"
            size="small"
            open={modalOpenSubirArchivo}
            setopen={handleOpenSubirArchivo}
            okfunc={handleSubmitVerificarArchivo}
            okDisabled={!listaFoliosArchivoVerificado}
            form
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    Seleccione el archivo .xls o .xlsx que contiene los nuevos folios y verifique el archivo cargado
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtProducto"
                        label={txtProducto.label}
                        required={txtProducto.required}
                        value={txtProducto.value}
                        error={txtProducto.error}
                        helperText={txtProducto.error && txtProducto.message}
                        onChange={handleChangeCargarArchivo}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        select
                        SelectProps={{
                            MenuProps: {
                                classes: { paper: classes.selectMain },
                                PaperProps: { style: { maxHeight: 400 } },
                            },
                        }}
                    >
                        <MenuItem value={""} hidden>
                            Seleccionar producto
                        </MenuItem>
                        {listaProductos.map((producto) => (
                            <MenuItem key={producto.iIdProducto} value={producto.iIdProducto.toString()}>
                                <i
                                    className="icon size-20"
                                    dangerouslySetInnerHTML={{ __html: `&#x${producto.sIcon};&nbsp;&nbsp;&nbsp;` }}
                                />
                                {"   "}
                                {producto.sNombre}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtArchivoFolios"
                        label={txtArchivoFolios.label}
                        required={txtArchivoFolios.required}
                        value={txtArchivoFolios.value}
                        error={txtArchivoFolios.error}
                        helperText={txtArchivoFolios.error && txtArchivoFolios.message}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title="Seleccionar archivo" arrow placement="top">
                                        <IconButton onClick={handleClickCargarArchivo}>
                                            <AttachFileIcon />
                                        </IconButton>
                                    </Tooltip>
                                    {archivoCargadoFolios && (
                                        <Fragment>
                                            <Tooltip title="Verificar folios del archivo" arrow placement="top">
                                                <IconButton onClick={handleClickVerificarArchivoFolios}>
                                                    <AssignmentTurnedInIcon className="color-1" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Limpiar campo" arrow placement="top">
                                                <IconButton onClick={handleClickLimpiarArchivo}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Fragment>
                                    )}
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                {listaFoliosArchivoVerificado && (
                    <Grid item xs={12}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Producto</TableCell>
                                        <TableCell>Folios</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>{listaFoliosArchivoVerificado.entProducto.sNombre}</TableCell>
                                        <TableCell>{listaFoliosArchivoVerificado.totalFolios}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                )}
            </Grid>
        </MeditocModal>
    );
}
